import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import ButtonComponent from '../../components/ButtonComponent';
import ChooseFileButton from '../../components/Files/ChooseFileButton';
import Layout from '../../components/Layout/Layout';
import { useMobile, useTablet } from '../../components/Layout/UseResponsive';
import SelectComponent from '../../components/SelectComponent';
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';
import Toast from '../../helpers/Toast';
import { ImportService } from '../../services/ImportService';
import {DownloadService} from '../../services/DownloadService';

export type SelectItemsProps = {
    label: string;
    value: string;
};

export default function ImportIndex() {

    const intl = useIntl();
    const importService = new ImportService();
    const downloadService = new DownloadService();

    const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);
    const [file, setFile] = useState<File | null>(null);
    const [resetFile, setResetFile] = useState<number>(0);

    const [reload, setReload] = useState<boolean>(false);

    const [selectedImportOption, setSelectedImportOption] = useState<string>("");
    const [assistanceTypesComponent, setImportOptionsComponent] = useState<SelectItemsProps[]>([]);
    const { importOptions } = useAvailableModulesContext();


    const onFileChange = (file: File | null) => {
        setFile(file);
    }

    const importFile = async () => {
        if (typeof file === "undefined" || file == null) {
            setFile(null);
            setResetFile(1);

            Toast.Show("error", intl.formatMessage({ id: "Common.Files.FilesPopup.FileMustBeSelected" }));
            return;
        }
        if (!selectedImportOption) {
            setFile(null);
            setResetFile(1);
            Toast.Show("error", intl.formatMessage({ id: "Common.Files.FilesPopup.ImportOption" }));
            return;
        }
        
        setIsButtonLoading(true);
        try {
            const formData = new FormData();
            formData.append("fileDto.File", file, file.name);
            formData.append("ImportOption", selectedImportOption);
            formData.append("Notes", "Importação");
        
            var response = await importService.ImportFile(formData);

            if (response.success === false) {
                Toast.Show("error", response.message);
                return;
            }
            setFile(null);
            setResetFile(1);
            Toast.Show("success", "Importado com sucesso");
            setReload(!reload);

        } catch (error: any) {
            setFile(null);
            setResetFile(1);

            Toast.Show("error", error.message);
        } finally {
            setFile(null);
            setResetFile(1);

            setIsButtonLoading(false);
        }

        setFile(null);
        setResetFile(1);
    };
    
    const DownloadFile = async () => {
        if (!selectedImportOption) {
            setFile(null);
            setResetFile(1);
            Toast.Show("error", intl.formatMessage({ id: "Common.Files.FilesPopup.ImportOption" }));
            return;
        }
    
        setIsButtonLoading(true);
        try {
            
            const response = await downloadService.DownloadFile(selectedImportOption);
    
            
            if (!response || !response.data) {
                Toast.Show("error", "Erro ao realizar o download do ficheiro.");
                return;
            }
    
            
            const fileName = `${selectedImportOption}.xlsx`;
    
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
    
            
            link.setAttribute("download", fileName);
    
            
            document.body.appendChild(link);
            link.click();
    
            
            document.body.removeChild(link);
    
            setFile(null);
            setResetFile(1);
            Toast.Show("success", "Download com sucesso");
            setReload(!reload);
    
        } catch (error: any) {
            setFile(null);
            setResetFile(1);
            Toast.Show("error", error.message);
        } finally {
            setFile(null);
            setResetFile(1);
            setIsButtonLoading(false);
        }
    };

    //obter opções de importação
    const getImportOptions = async () => {
        const list: SelectItemsProps[] = [];

        importOptions.forEach((element) => {
            var item: SelectItemsProps = {
                value: element,
                label: element,
            };
            list.push(item);
        });

        setImportOptionsComponent(list);
    };
    useEffect(() => {
        getImportOptions();
    }, []);

    const isMobile = useMobile();
    const isTablet = useTablet();

    return (
        <>
            <Layout>
                <div className="pageContainer">
                    <div className="pageHeader">
                        <span className="pageTitle">
                            <FormattedMessage id="Screens.Imports.Title" />
                        </span>
                    </div>

                    <div className="pageBody">
                        <Row style={{ margin: "1rem 0px" }} >
                            <SelectComponent
                                xl={2}
                                lg={2}
                                md={2}
                                sm={12}
                                xs={12}
                                style={{
                                    width: isMobile ? "100%" : isTablet ? "64%" : "98%",
                                    height: "43px"
                                }}
                                label={"Tipo de Importação"}
                                selectedItemValue={selectedImportOption}
                                items={assistanceTypesComponent}
                                onChange={(t: string) => {
                                    setSelectedImportOption(t);
                                }}
                            />
                            <Col xl={6} lg={6} md={6} sm={12} xs={12} style={{ marginTop: "1rem" }}>
                                <ChooseFileButton
                                    reset={resetFile}
                                    onFileChange={onFileChange}
                                    selectedFileStyleMarginLeft={isMobile || isTablet ? { marginLeft: "0" } : { marginLeft: "-33%" }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ margin: "1rem 0px" }} >
                            <Col xl={3} lg={3} sm={12} xs={12}>
                                <ButtonComponent
                                    style={{
                                        width: isMobile ? "100%" : isTablet ? "64%" : "98%",
                                        height: "100%"
                                    }}
                                    onClick={() => importFile()}
                                    text={intl.formatMessage({ id: "Screens.Imports.Import" })}
                                    loading={isButtonLoading}
                                />
                            </Col>
                            <Col xl={3} lg={3} sm={12} xs={12}>
                                <ButtonComponent
                                    style={{
                                        width: isMobile ? "100%" : isTablet ? "64%" : "98%",
                                        height: "100%"
                                    }}
                                    onClick={() => DownloadFile()}
                                    text={intl.formatMessage({ id: "Download de Modelo" })}
                                    loading={isButtonLoading}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            </Layout>
        </>
    );
}
